import { c as _c } from "react/compiler-runtime";
import { ZIN_DISPLAY_KEY_STORY_VILLA_CITY_PAGE, ZIN_KEY } from "@website/accommodation-ui/constant";
import { HotelCitiesMainContent } from "@website/accommodation-ui/hotel-cities-main-content";
import { HotelFilter } from "@website/accommodation-ui/hotel-filter";
import { HotelListHeader } from "@website/accommodation-ui/hotel-list-header";
import { HotelPagination } from "@website/accommodation-ui/hotel-pagination";
import { HotelShortVideos } from "@website/accommodation-ui/hotel-short-videos";
import { HotelUpdateSearchModal } from "@website/accommodation-ui/hotel-update-search-modal";
import { VillaMeta } from "@website/accommodation-ui/villa-meta";
import { VillaSearch } from "@website/accommodation-ui/villa-search";
import { MaterialIcon } from "@website/icons/material";
import { Breadcrumb } from "@website/ui/breadcrumb";
import { isChannel } from "@website/utils/channel/helpers";
import { BannerSlide } from "@website/widget/banner-slide";
import { Footer } from "@website/widget/footer";
import { Header } from "@website/widget/header";
import { AnimatedButton } from "@website/widget/search-map/animatedButton";
import { SeoComponents } from "@website/widget/seo-components";
import { Telesales } from "@website/widget/telesales";
import { NextPage } from "next";
import { useRouter } from "next/router";
import { FC } from "react";
import Custom404 from "../../[...gone].page";
import { useCityPage } from "./index.hook";
import { CityPagePropertiesType } from "./index.types";
const CityPageContent: FC<CityPagePropertiesType> = properties => {
  const $ = _c(59);
  const router = useRouter();
  const {
    headerProps,
    modalProps,
    searchProperties,
    citiesFilterProperties,
    hotelListHeaderProps,
    hotelPaginationProps,
    hotelCitiesMainContentProps,
    hotelBreadcrumbsProperties,
    telesaleProperties,
    bannersProperties,
    onMapClick,
    hasMap
  } = useCityPage(properties);
  const zinStoryTag = `${router?.query?.locationType}/${router?.query?.cityTitle}`;
  const t0 = properties?.seoData?.title;
  const t1 = properties?.seoData?.description;
  const t2 = properties.locationData?.type;
  const t3 = properties.locationData?.title;
  let t4;
  if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2 || $[3] !== t3) {
    t4 = <VillaMeta title={t0} description={t1} locationType={t2} locationTitle={t3} />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== modalProps) {
    t5 = <HotelUpdateSearchModal {...modalProps} />;
    $[5] = modalProps;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== headerProps) {
    t6 = <Header {...headerProps} />;
    $[7] = headerProps;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="bg-outline-thin h-px w-full" />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== searchProperties) {
    t8 = <VillaSearch {...searchProperties} />;
    $[10] = searchProperties;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== hotelBreadcrumbsProperties) {
    t9 = <div className="hidden lg:flex"><Breadcrumb {...hotelBreadcrumbsProperties} className="hidden lg:flex" /></div>;
    $[12] = hotelBreadcrumbsProperties;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== bannersProperties?.bannerSlideList) {
    t10 = bannersProperties?.bannerSlideList?.length > 0 && <div className="hidden w-[312px] pb-4 xl:block"><BannerSlide className="p-0" list={bannersProperties?.bannerSlideList} /></div>;
    $[14] = bannersProperties?.bannerSlideList;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== citiesFilterProperties) {
    t11 = <HotelFilter {...citiesFilterProperties} />;
    $[16] = citiesFilterProperties;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t11) {
    t12 = <div className="p-0">{t10}{t11}</div>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== hotelListHeaderProps) {
    t13 = <HotelListHeader {...hotelListHeaderProps} />;
    $[21] = hotelListHeaderProps;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== zinStoryTag) {
    t14 = <HotelShortVideos className="bg-on-color-high-emphasis -mx-6 -mt-5 px-4 lg:m-0 lg:hidden" displayType="STORY" displayId={ZIN_DISPLAY_KEY_STORY_VILLA_CITY_PAGE} zinKey={ZIN_KEY} zinTags={zinStoryTag} />;
    $[23] = zinStoryTag;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== hotelCitiesMainContentProps) {
    t15 = <HotelCitiesMainContent {...hotelCitiesMainContentProps} />;
    $[25] = hotelCitiesMainContentProps;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== hotelPaginationProps || $[28] !== t15) {
    t16 = <HotelPagination {...hotelPaginationProps}>{t15}</HotelPagination>;
    $[27] = hotelPaginationProps;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== hasMap || $[31] !== onMapClick) {
    t17 = hasMap && <AnimatedButton className="bottom-[20px] self-center md:bottom-6 md:!self-auto xl:!hidden" icon={<MaterialIcon name="map" variant="outlined" />} onClick={onMapClick} text={"\u0646\u0645\u0627\u06CC\u0634 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647\u200C\u0647\u0627 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647"} />;
    $[30] = hasMap;
    $[31] = onMapClick;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t13 || $[34] !== t14 || $[35] !== t16 || $[36] !== t17) {
    t18 = <main className="flex min-w-0 shrink grow flex-col gap-5 lg:gap-4">{t13}{t14}{t16}{t17}</main>;
    $[33] = t13;
    $[34] = t14;
    $[35] = t16;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t12 || $[39] !== t18) {
    t19 = <div className="relative flex">{t12}{t18}</div>;
    $[38] = t12;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== properties.seoData) {
    t20 = <div className="w-full px-6 py-2 xl:mx-auto xl:max-w-[1200px]"><SeoComponents seoData={properties.seoData} linksTitle={"\u0627\u062C\u0627\u0631\u0647 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647 \u062F\u0631 \u0634\u0647\u0631\u0647\u0627\u06CC \u067E\u0631\u0637\u0631\u0641\u062F\u0627\u0631"} /></div>;
    $[41] = properties.seoData;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== telesaleProperties) {
    t21 = !isChannel(["b2b", "telesale"]) && <Telesales {...telesaleProperties} />;
    $[43] = telesaleProperties;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Footer />;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t19 || $[47] !== t20 || $[48] !== t21 || $[49] !== t9) {
    t23 = <div className="flex flex-col gap-5 px-6 lg:py-5 xl:mx-auto xl:max-w-[1200px] xl:px-0">{t9}{t19}{t20}{t21}{t22}</div>;
    $[46] = t19;
    $[47] = t20;
    $[48] = t21;
    $[49] = t9;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== t23 || $[52] !== t5 || $[53] !== t6 || $[54] !== t8) {
    t24 = <div className="bg-dim-background">{t5}{t6}{t7}{t8}{t23}</div>;
    $[51] = t23;
    $[52] = t5;
    $[53] = t6;
    $[54] = t8;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== t24 || $[57] !== t4) {
    t25 = <>{t4}{t24}</>;
    $[56] = t24;
    $[57] = t4;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  return t25;
};
const Index: NextPage<CityPagePropertiesType> = properties => {
  const $ = _c(3);
  if (!properties.locationData) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Custom404 />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== properties) {
    t0 = <CityPageContent {...properties} />;
    $[1] = properties;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default Index;
export { getServerSideProps } from "./index.server";